import React from "react";
import { Outlet } from "react-router-dom";
import { VideoCallProvider } from "contexts/VideoCallContext.jsx";

import { ChatWidget } from "components/ChatWidget/chat-widget";
import { Header } from "components/Header/Header";
import { Sidebar } from "components/Sidebar/Sidebar";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { useStaffPresenceHeartbeat } from "hooks/useStaffPresenceHeartbeat";

// Local dev escape hatch: set REACT_APP_DISABLE_CHAT=true to stop the team
// chat widget mounting and the presence heartbeat firing, silencing the
// getmychats / unread-summary / groups / heartbeat polling. Unset in CI/prod.
const isChatDisabled = process.env.REACT_APP_DISABLE_CHAT === "true";

const AuthenticatedLayout = () => {
  useStaffPresenceHeartbeat({ enabled: !isChatDisabled });
  const patientId = useCurrentPatientId();

  return (
    <VideoCallProvider patientId={patientId}>
      <div className="App">
        <div className="dashboard">
          <Sidebar />
          <div className="main-content">
            <Header />
            <div className="main-content-wrapper">
              <Outlet />
            </div>
          </div>
        </div>
        {!isChatDisabled && <ChatWidget />}
      </div>
    </VideoCallProvider>
  );
};

export { AuthenticatedLayout };
